var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c("div", { staticClass: "field" }, [
      _c("input", {
        directives: [
          {
            name: "model",
            rawName: "v-model",
            value: _vm.innerValue.detail,
            expression: "innerValue.detail",
          },
        ],
        staticClass: "is-checkradio",
        attrs: { id: "detail-invoice", type: "radio", name: "detail-invoice" },
        domProps: { value: true, checked: _vm._q(_vm.innerValue.detail, true) },
        on: {
          change: function ($event) {
            return _vm.$set(_vm.innerValue, "detail", true)
          },
        },
      }),
      _c("label", { attrs: { for: "detail-invoice" } }, [
        _vm._v("Detail Invoice"),
      ]),
      _c("input", {
        directives: [
          {
            name: "model",
            rawName: "v-model",
            value: _vm.innerValue.detail,
            expression: "innerValue.detail",
          },
        ],
        staticClass: "is-checkradio",
        attrs: {
          id: "one-line-invoice",
          type: "radio",
          name: "one-line-invoice",
        },
        domProps: {
          value: false,
          checked: _vm._q(_vm.innerValue.detail, false),
        },
        on: {
          change: function ($event) {
            return _vm.$set(_vm.innerValue, "detail", false)
          },
        },
      }),
      _c("label", { attrs: { for: "one-line-invoice" } }, [
        _vm._v("1-Line Invoice"),
      ]),
    ]),
    _c("div", { staticClass: "is-divider" }),
    _c("div", { staticClass: "field" }, [
      _c("input", {
        directives: [
          {
            name: "model",
            rawName: "v-model",
            value: _vm.innerValue.itemNumber,
            expression: "innerValue.itemNumber",
          },
        ],
        staticClass: "is-checkradio",
        attrs: {
          id: "itemNumber",
          type: "checkbox",
          checked: "checked",
          name: "itemNumber",
          disabled: !_vm.innerValue.detail,
        },
        domProps: {
          checked: Array.isArray(_vm.innerValue.itemNumber)
            ? _vm._i(_vm.innerValue.itemNumber, null) > -1
            : _vm.innerValue.itemNumber,
        },
        on: {
          change: function ($event) {
            var $$a = _vm.innerValue.itemNumber,
              $$el = $event.target,
              $$c = $$el.checked ? true : false
            if (Array.isArray($$a)) {
              var $$v = null,
                $$i = _vm._i($$a, $$v)
              if ($$el.checked) {
                $$i < 0 &&
                  _vm.$set(_vm.innerValue, "itemNumber", $$a.concat([$$v]))
              } else {
                $$i > -1 &&
                  _vm.$set(
                    _vm.innerValue,
                    "itemNumber",
                    $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                  )
              }
            } else {
              _vm.$set(_vm.innerValue, "itemNumber", $$c)
            }
          },
        },
      }),
      _c("label", { attrs: { for: "itemNumber" } }, [_vm._v("Item Number")]),
      _c("input", {
        directives: [
          {
            name: "model",
            rawName: "v-model",
            value: _vm.innerValue.individualPartPrice,
            expression: "innerValue.individualPartPrice",
          },
        ],
        staticClass: "is-checkradio",
        attrs: {
          id: "individualPartPrice",
          type: "checkbox",
          checked: "checked",
          name: "individualPartPrice",
          disabled: !_vm.innerValue.detail,
        },
        domProps: {
          checked: Array.isArray(_vm.innerValue.individualPartPrice)
            ? _vm._i(_vm.innerValue.individualPartPrice, null) > -1
            : _vm.innerValue.individualPartPrice,
        },
        on: {
          change: function ($event) {
            var $$a = _vm.innerValue.individualPartPrice,
              $$el = $event.target,
              $$c = $$el.checked ? true : false
            if (Array.isArray($$a)) {
              var $$v = null,
                $$i = _vm._i($$a, $$v)
              if ($$el.checked) {
                $$i < 0 &&
                  _vm.$set(
                    _vm.innerValue,
                    "individualPartPrice",
                    $$a.concat([$$v])
                  )
              } else {
                $$i > -1 &&
                  _vm.$set(
                    _vm.innerValue,
                    "individualPartPrice",
                    $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                  )
              }
            } else {
              _vm.$set(_vm.innerValue, "individualPartPrice", $$c)
            }
          },
        },
      }),
      _c("label", { attrs: { for: "individualPartPrice" } }, [
        _vm._v("Individual Part Price"),
      ]),
    ]),
    _c("div", { staticClass: "field" }, [
      _c("input", {
        directives: [
          {
            name: "model",
            rawName: "v-model",
            value: _vm.innerValue.PartPriceInclMarkup,
            expression: "innerValue.PartPriceInclMarkup",
          },
        ],
        staticClass: "is-checkradio",
        attrs: {
          id: "PartPriceInclMarkup",
          type: "checkbox",
          checked: "checked",
          name: "PartPriceInclMarkup",
          disabled: !_vm.innerValue.detail,
        },
        domProps: {
          checked: Array.isArray(_vm.innerValue.PartPriceInclMarkup)
            ? _vm._i(_vm.innerValue.PartPriceInclMarkup, null) > -1
            : _vm.innerValue.PartPriceInclMarkup,
        },
        on: {
          change: function ($event) {
            var $$a = _vm.innerValue.PartPriceInclMarkup,
              $$el = $event.target,
              $$c = $$el.checked ? true : false
            if (Array.isArray($$a)) {
              var $$v = null,
                $$i = _vm._i($$a, $$v)
              if ($$el.checked) {
                $$i < 0 &&
                  _vm.$set(
                    _vm.innerValue,
                    "PartPriceInclMarkup",
                    $$a.concat([$$v])
                  )
              } else {
                $$i > -1 &&
                  _vm.$set(
                    _vm.innerValue,
                    "PartPriceInclMarkup",
                    $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                  )
              }
            } else {
              _vm.$set(_vm.innerValue, "PartPriceInclMarkup", $$c)
            }
          },
        },
      }),
      _c("label", { attrs: { for: "PartPriceInclMarkup" } }, [
        _vm._v("Part Prices incl. Markup"),
      ]),
    ]),
    _c("div", { staticClass: "is-divider" }),
    _c("div", { staticClass: "field" }, [
      _c("label", { staticClass: "label" }, [_vm._v("Labour Print Options")]),
      _c("input", {
        directives: [
          {
            name: "model",
            rawName: "v-model",
            value: _vm.innerValue.labourPrintOption,
            expression: "innerValue.labourPrintOption",
          },
        ],
        staticClass: "is-checkradio",
        attrs: {
          id: "lumpSum",
          type: "radio",
          name: "lumpSum",
          disabled: !_vm.innerValue.detail,
        },
        domProps: {
          value: _vm.labourPrintOptionTypes.LumpSum,
          checked: _vm._q(
            _vm.innerValue.labourPrintOption,
            _vm.labourPrintOptionTypes.LumpSum
          ),
        },
        on: {
          change: function ($event) {
            return _vm.$set(
              _vm.innerValue,
              "labourPrintOption",
              _vm.labourPrintOptionTypes.LumpSum
            )
          },
        },
      }),
      _c("label", { attrs: { for: "lumpSum" } }, [_vm._v("Lump Sum")]),
      _c("input", {
        directives: [
          {
            name: "model",
            rawName: "v-model",
            value: _vm.innerValue.labourPrintOption,
            expression: "innerValue.labourPrintOption",
          },
        ],
        staticClass: "is-checkradio",
        attrs: {
          id: "category",
          type: "radio",
          name: "category",
          disabled: !_vm.innerValue.detail,
        },
        domProps: {
          value: _vm.labourPrintOptionTypes.Category,
          checked: _vm._q(
            _vm.innerValue.labourPrintOption,
            _vm.labourPrintOptionTypes.Category
          ),
        },
        on: {
          change: function ($event) {
            return _vm.$set(
              _vm.innerValue,
              "labourPrintOption",
              _vm.labourPrintOptionTypes.Category
            )
          },
        },
      }),
      _c("label", { attrs: { for: "category" } }, [_vm._v("Category")]),
      _c("input", {
        directives: [
          {
            name: "model",
            rawName: "v-model",
            value: _vm.innerValue.labourPrintOption,
            expression: "innerValue.labourPrintOption",
          },
        ],
        staticClass: "is-checkradio",
        attrs: {
          id: "detailed",
          type: "radio",
          name: "detailed",
          disabled: !_vm.innerValue.detail,
        },
        domProps: {
          value: _vm.labourPrintOptionTypes.Detailed,
          checked: _vm._q(
            _vm.innerValue.labourPrintOption,
            _vm.labourPrintOptionTypes.Detailed
          ),
        },
        on: {
          change: function ($event) {
            return _vm.$set(
              _vm.innerValue,
              "labourPrintOption",
              _vm.labourPrintOptionTypes.Detailed
            )
          },
        },
      }),
      _c("label", { attrs: { for: "detailed" } }, [_vm._v("Detailed")]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }